// user clicks on this to flag the prompt
// used in promptpage/PromptBottomMenu.js
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@mui/styles';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';
import FormControlLabel from '@mui/material/FormControlLabel';
import { flagPrompt, closeModal } from '../../actions';
import {
  flagPromptType,
  closeModalType,
  promptIDType,
  classesType,
  promptCreatorIDType,
  promptCreatorType,
  promptTitleType
} from '../../types';

const styles = theme => ({
  comments: {
    '& label.Mui-focused': {
      color: theme.palette.text.primary // readable focused label in light and dark
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: theme.palette.text.primary // readable focused underline in light and dark
    }
  }
});

class FlagPromptModal extends Component {
  state = {
    reason: '',
    comment: ''
  };

  handleSelection = event => {
    this.setState({ reason: event.target.value });
  };

  handleComment = event => {
    this.setState({ comment: event.target.value });
  };

  // submits the selected reason from radio button and the comments
  handleSubmit = () => {
    const { reason, comment } = this.state;
    const {
      promptID,
      promptCreatorID,
      promptCreator,
      promptTitle
    } = this.props;
    const flagObject = {
      promptID,
      reason,
      comment,
      promptCreatorID,
      promptCreator,
      promptTitle
    };
    this.props.flagPrompt(flagObject);
    this.props.closeModal();
  };

  render() {
    return (
      <>
        <Dialog
          open
          onClose={this.props.closeModal}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="form-dialog-title">Report Prompt</DialogTitle>
          <DialogContent>
            <DialogContentText>
              We&apos;re sorry something&apos;s wrong. How can we help?
              {/* that dialogue is from reddit report, change it to something original */}
            </DialogContentText>
            <RadioGroup
              aria-label="reasons"
              name="reasons"
              value={this.state.reason}
              onChange={this.handleSelection}
            >
              <FormControlLabel
                value="spam"
                control={<Radio color="default" />}
                label="Spam"
              />
              <FormControlLabel
                value="harrassment"
                control={<Radio color="default" />}
                label="Harrassment or abusive content"
              />
              <FormControlLabel
                value="underage"
                control={<Radio color="default" />}
                label="Underage content or role"
              />
              <FormControlLabel
                value="money"
                control={<Radio color="default" />}
                label="Offering or soliciting money"
              />
              <FormControlLabel
                value="image/link"
                control={<Radio color="default" />}
                label="Inappropriate image or link"
              />
              <FormControlLabel
                value="copying"
                control={<Radio color="default" />}
                label="Copying someone else's content"
              />
              <FormControlLabel
                value="other"
                control={<Radio color="default" />}
                label="Other reason"
              />
            </RadioGroup>
            <TextField
              id="Additional Comments"
              label="Additional Comments"
              type="text"
              multiline
              rows={3}
              fullWidth
              value={this.state.comment}
              onChange={this.handleComment}
              className={this.props.classes.comments}
            />
          </DialogContent>
          <DialogActions>
            <Button
              onClick={this.props.closeModal}
              // color="primary"
              // variant="contained"
            >
              Cancel
            </Button>
            <Button
              onClick={this.handleSubmit}
              color="primary"
              variant="contained"
              disabled={!this.state.reason}
            >
              Submit
            </Button>
          </DialogActions>
        </Dialog>
      </>
    );
  }
}

FlagPromptModal.propTypes = {
  flagPrompt: flagPromptType.isRequired,
  closeModal: closeModalType.isRequired,
  promptID: promptIDType.isRequired,
  classes: classesType.isRequired,
  promptCreatorID: promptCreatorIDType.isRequired,
  promptCreator: promptCreatorType.isRequired,
  promptTitle: promptTitleType.isRequired
};

const actions = { flagPrompt, closeModal };

export default withStyles(styles)(connect(null, actions)(FlagPromptModal));
